<button  mat-flat-button color="primary" style="padding: 0 20px"
    class="button-icon-text" (click)="redirectToSlaveManagement()" class="button-icon-text" [disabled]="setDisabled()">
    <mat-icon>add</mat-icon><span matTooltip="{{ 'COMMONS.SUB_ADD_SUBORDINATED_TOOLTIP' | translate }}" matTooltipClass="tooltip-layout" translate>ADD_SLAVE_SUBSCRIPTION_2</span>
</button>



